import React, { useRef } from 'react';
import { Checkbox, FormControlLabel, Stack } from '@mui/material';

import { BeamPocketLayoutFeatureArea } from '@paragon/contract-library';
import { DistanceField, NumericField } from '@paragon/material';

import { OptionallyNullableFieldWrapper } from '../../../../controls/OptionallyNullableFieldWrapper';

interface Props {
  value: Omit<BeamPocketLayoutFeatureArea, 'guid'>;
  disabled?: boolean;
  onChange: (value: Omit<BeamPocketLayoutFeatureArea, 'guid'>) => void;
}

export function BeamPocketFeatureAreaControls({ value, disabled, onChange }: Props) {
  const beamWidthRef = useRef<HTMLInputElement>(null);

  return (
    <>
      <OptionallyNullableFieldWrapper
        inputRef={beamWidthRef}
        property="Beam Width"
        disabled={disabled}
        value={value.beamWidth}
        onMadeNull={() => {
          onChange({ ...value, beamWidth: null });
        }}
      >
        <DistanceField
          inputRef={beamWidthRef}
          label="Beam Width"
          canBeNull
          disabled={disabled}
          value={value.beamWidth}
          onSubmit={(beamWidth) => {
            onChange({ ...value, beamWidth });
          }}
        />
      </OptionallyNullableFieldWrapper>

      <DistanceField
        label="Pocket Height"
        disabled={disabled}
        value={value.pocketHeight}
        onSubmit={(pocketHeight) => {
          onChange({ ...value, pocketHeight });
        }}
      />

      <FormControlLabel
        disabled={disabled}
        label="Bottom Chord Cut Out"
        control={
          <Checkbox
            checked={value.bottomChordCutOut}
            onChange={(_, checked) => {
              onChange({ ...value, bottomChordCutOut: checked });
            }}
          />
        }
      />

      <Stack direction="row" spacing={1}>
        <NumericField
          label="Left Verticals"
          disabled={disabled}
          value={value.leftVerticalsCount}
          onSubmit={(leftVerticalsCount) => {
            onChange({ ...value, leftVerticalsCount });
          }}
        />

        <NumericField
          label="Right Verticals"
          disabled={disabled}
          value={value.rightVerticalsCount}
          onSubmit={(rightVerticalsCount) => {
            onChange({ ...value, rightVerticalsCount });
          }}
        />
      </Stack>
    </>
  );
}
